var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-popup',{ref:"commonPopup",attrs:{"closeOnClickModal":true,"position":'top'}},[_c('img',{attrs:{"src":"https://h5.yueyuechuxing.cn/yueyue/app_download/img/ios-prompt.813477aa.png","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }